"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BlockTypeRegistry = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
class BlockTypeRegistry {
  constructor() {
    (0, _defineProperty2.default)(this, "types", {});
  }
  register(type, factory) {
    this.types[type] = factory;
    return this;
  }
  create(type, params, variableTypes) {
    if (!this.types[type]) {
      throw new Error(`Type ${type} block not registered`);
    }
    return new this.types[type](params, variableTypes);
  }
  settings(type) {
    var _this$types$type;
    return (_this$types$type = this.types[type]) === null || _this$types$type === void 0 ? void 0 : _this$types$type.settings;
  }
  primarySetting(type) {
    var _this$types$type2;
    return (_this$types$type2 = this.types[type]) === null || _this$types$type2 === void 0 ? void 0 : _this$types$type2.primarySetting;
  }
}
exports.BlockTypeRegistry = BlockTypeRegistry;
//# sourceMappingURL=BlockTypeRegistry.js.map